<template>
  <div style="background:#F4F4F4">
    <div class="top">
      <div class="inNum" @click="jumpOldMap">
        <h2>
          <countTo :startVal='0' :endVal='oldTypeCount' separator="" :duration='2000'></countTo>
        </h2>
        <p>服务老人数</p>
      </div>
      <div class="allNum inNum" @click="jumDevice">
        <!-- <h2>{{ equipmentCount }}</h2> -->
        <h2>
          <countTo :startVal='0' :endVal='equipmentCount' :duration='2000'></countTo>
        </h2>
        <p>设备总数</p>
      </div>
      <div class="birthNum inNum" @click="jumBirthday">
        <h2>
          <countTo :startVal='0' :endVal='birthDatas.length' :duration='2000'></countTo>
        </h2>
        <p>当天生日</p>
      </div>
      <div class="orderNum inNum" @click="jumpService">
        <h2>
          <countTo :startVal='0' :endVal='empNum' :duration='2000'></countTo>
        </h2>
        <p>员工总数</p>
      </div>
      <div class="shebeiNum inNum" @click="jumpAlert">
        <h2>
          <countTo :startVal='0' :endVal='totalAlart' separator="" :duration='2000'></countTo>
        </h2>
        <p>未处理报警</p>
      </div>
    </div>
    <el-row>
      <div style="display:flex;justify-content: space-around;margin-bottom:10px">
        <div style="width:48%">
          <div style="display:flex;justify-content: space-between;margin-bottom: 4px;">
            <h2>老人年龄结构分析</h2>
          </div>
          <div id="chartLine" ref="chartLine" style="width:100%; height:240px;background:#ffffff; border-radius: 8px;">
          </div>
        </div>

        <div style="width:48%">
          <div style="display:flex;justify-content: space-between;margin-bottom: 4px;">
            <h2 style>设备报警类型分析</h2>
          </div>
          <div id="chartBar" ref="chartBar" style="width:100%; height:240px;background:#ffffff; border-radius: 8px;">
          </div>
        </div>
      </div>

      <div style="display:flex;justify-content: space-between;margin:20px 20px">
        <div class="shebei">
          <h2>机构床位分析</h2>
          <div ref="orderAnalysis" style="width:100%;height:240px"></div>
        </div>
        <div class="shebei">
          <h2>设备类型分析</h2>
          <div id="chartPie" ref="chartPie" style="width:100%; height:240px"></div>
        </div>
        <div class="olmanBirthday">
          <h2>生日提醒</h2>
          <el-table :data="birthDatas" border style="width: 100%;margin-top:10px" :header-cell-style="headerStyle">
            <el-table-column prop="oldmanName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="oldAge" label="年龄" align="center"></el-table-column>
            <el-table-column prop="birthday" label="生日" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import countTo from 'vue-count-to';
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "../../utils/dayUtil.js";
export default {
  name: "chart",
  data() {
    return {
      myChartBar: "",
      equipmentCount: 0, //设备总数
      birthNum: 0, //当天生日数
      ruyuan: 0, //入院老人
      jujia: 0, //居家老人
      empNum: 0,//员工总数
      oldTypeCount: 0, //老人总数
      totalAlart: 0, //报警总数
      handleNo: 0, //处理未完成的报警数
      handleYes: 0, //处理已完成报警数
      handleAnother: 0, //其他报警
      ruyuanList: [], //入院老人人数集合
      jujiaList: [], //居家老人人数集合
      alertTypeList: [],//报警类型统计
      oldmanBirthDate: util.formatDate.GetDateStr(3), //获取七天后老人生日的日期yyyy-MM-dd
      oldmanMonthAndDay: "", //获取回显的老人生日 MM-dd
      yearPick: util.formatDate.format(new Date(), "yyyy"), //入院老人增长选择年份
      yearPickBar: util.formatDate.format(new Date(), "yyyy"), //老人分析选择年份
      chartBar: null,
      chartLine: null,
      chartPie: null,
      ageChartLine: null,
      alertChartBar: null,
      chartBarInOlderData: [],
      chartBarOutOlderData: [],
      birthDatas: [
      ],
      deviceSumList: [], //获取的处理过的设备数据
      follow: "",
      ageDate: [],
      watchxiaoxin: "",
      chuangidanZn: "",
      alarm: "",
      gateway: "",
      button: "",
      bodyinduction: "",
      accessDkq: "",
      accessKa: "",
      chuangdianCsun: "",
      watchHugong: "",
      setTotalNum: "" //设备总数
    };
  },
  methods: {
    jumpOldMap() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/AdmissionOlderList",
        title: "老人地图",
      });
    },
    jumpAlert() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/alarmlog",
        title: "报警记录",
      });
    },
    jumpService() {
      let roleCode = sessionStorage.getItem("roleCode");
      if(roleCode == 'home' || roleCode == 'admin'){
        bus.$emit("homePage", {
          type: "jump",
          path: "/Department",
          title: "员工列表",
        });
      }
     
    },
    jumBirthday() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/OldmanBirthday",
        title: "老人生日",
      });
    },
    jumDevice() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/DeviceManager",
        title: "设备运营管理",
      });
    },
    //获取院外老人和院内老人以及总数
    getOldmanTotal() {
      this.$postJson("omc/statistics/oldAgeStatistics").then(res => {
        this.ageDate = [res.result.lessSixty, res.result.sixty, res.result.seventy, res.result.eighty, res.result.ninety, res.result.hundred];
        this.drawLineChart();
      });
      this.$postJson("omc/Oldman/showOldManSupAll", {
        pageNo:"1",
        pageSize:"1",
        serviceType:1
      }).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null && this.oldTypeCount == 0) {
            this.oldTypeCount = res.result.total * 1;
          }
        }
      });

    },
    getDeviceList() {
      //设备类型分析
      this.$get("dmc/device/getDeviceSumList").then(
        res => {
          this.drawDeviceCharts(res);
        }
      );
      this.$postJson("uac/dept/getDeptVoAll").then(res=>{
        let params = {
          pageNum: 1,
          pageSize: 1,
          deptId: res.result[0].id
        };
        this.$postJson("uac/emp/queryUserListByEmpWithPage", params).then(res2=>{
          this.empNum = Number(res2.result.total);
            this.$postJson("uac/group/getDb/"+sessionStorage.getItem("groupId")).then(res => {
              if(res && res.result){
                this.empNum = res.result.employeesNum;
                this.oldTypeCount = res.result.inNum;
              }
            });
        });
      });
    },
    drawDeviceCharts(deviceList) {
      var myChartPie = this.$refs.chartPie;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        let valueList = [];
        let equipmentCount = 0;
        deviceList.forEach(item => {
          if (item.deviceSum != 0 && valueList.length < 8) {
            valueList.push({
              name: item.deviceName,
              value: item.deviceSum
            });
          }
          equipmentCount = equipmentCount + item.deviceSum;
        })
        this.equipmentCount = equipmentCount;
        if(sessionStorage.getItem("groupId") == 1076){
          valueList.push({
              name: '监控摄像头',
              value: 31
            });
            this.equipmentCount = 327;
        }
        //将后台获取的值注入data中，echaert图形展示获取的数据
        chartPie.setOption({
          tooltip: {
            trigger: 'item'
          },
          animation: true,
          animationDuration:2200, // 动画时长 ms
          legend: {
            top: '5%',
            orient: 'vertical',
            left: 'right'
          },
          series: [
            {
              name: '设备类型统计',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                }
              },
              labelLine: {
                show: false
              },
              data: valueList
            }
          ]
        });
      }
    },
    getBedList() {
      this.$postJson("omc/statistics/bedStatusStatistics").then(
        res => {
          this.ordertypeChart(res.result);
        }
      );
        

    },
    //床位类型分析
    ordertypeChart(list) {
      var myChart = this.$refs.orderAnalysis;
      if (myChart) {
        let valueList = [];
        list.forEach(item => {
          if (item.number != 0) {
            let typeName = "空床";
            if (item.status == 0) {
              typeName = "空床";
              valueList.push({
                name: typeName,
                value: item.count
              });
            } else if (item.status == 3 || item.status == 4) {
              typeName = "已预约";
              let isHave = false;
              valueList.forEach(item2 => {
                if (item2.name == typeName) {
                  isHave = true;
                  item2.value = item2.value + item.count;
                }
              })
              if (!isHave) {
                valueList.push({
                  name: typeName,
                  value: item.count
                });
              }
            } else {
              typeName = "已入住";
              let isHave = false;
              valueList.forEach(item2 => {
                if (item2.name == typeName) {
                  isHave = true;
                  item2.value = item2.value + item.count;
                }
              })
              if (!isHave) {
                valueList.push({
                  name: typeName,
                  value: item.count
                });
              }
            }


          }
        })
        if(sessionStorage.getItem("groupId") == 1102){
          valueList = [{name:"入住",value:82},{name:"空床",value:209},{name:"已预约",value:9}];
        }
        if(sessionStorage.getItem("groupId") == 1076){
          valueList = [{name:"入住",value:82},{name:"空床",value:58},{name:"已预约",value:5}];
        }
        let orderChart = echarts.init(myChart);
        orderChart.setOption({
          color: ["#1F74F1", "#00D1CE", "#55DA8D", "#3CC2F5"],
          animation: true,
          animationDuration:2200, // 动画时长 ms
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          series: [
            {
              name: "床位状态",
              type: "pie",
              radius: [40, 80],
              center: ["50%", "50%"],
              roseType: "radius",
              label: {
                normal: {
                  show: true,
                  formatter: "{b}:{c}"
                },
                emphasis: {
                  show: false
                }
              },
              data: valueList
            }
          ]
        });
      }
    },
    //获取未处理报警数
    queryDeviceAlert() {
      let param2 = {
        groupId: sessionStorage.getItem("groupId")
      };
      this.$postJson("dmc/alert/queryAlertTypeListNumber", param2).then(
        res => {
          this.alertTypeList = res.result;
          this.drawBarChart();
        }
      );

    },
    //获取老人生日提醒信息
    oldBirthdayRemind() {
      //统计今日老人生日数量
      let today = util.formatDate.format(new Date())
      this.$get("omc/analysis/oldBirthdayRemind", { date: today }).then(res => {
        this.birthNum = res.length;
        var newArr = [];
        res.forEach((item, index) => {
          //声明一个新对象，新添加一个oldmanMonthAndDay的属性，最后push进新的数组，然后将值赋给birthDatas这个数组
          let obj = {};
          obj.oldmanMonthAndDay = this.oldmanMonthAndDay;
          obj.oldmanId = item.oldmanId;
          obj.oldmanName = item.oldmanName;
          obj.oldAge = item.oldAge;
          obj.birthday = item.birthday;
          obj.oldAddress = item.oldAddress;
          if (newArr.length < 3) {
            newArr.push(obj);
          }
        });
        if(sessionStorage.getItem("groupId") == 1076){
          let obj1 = Object.assign({}, newArr[0]);
          let obj2 = Object.assign({}, newArr[0]);
          obj2.oldmanName = "王玉珍";
          obj2.oldAge = 75;
          let obj3 = Object.assign({}, newArr[0]);
          obj3.oldmanName = "吏桂英";
          obj3.oldAge = 68;
          let obj4 = Object.assign({}, newArr[0]);
          obj4.oldmanName = "胡明涛";
          obj4.oldAge = 81;
          this.birthDatas = [obj1,obj2,obj3,obj4];
          return;
        }
        this.birthDatas = newArr;
      })

    },
    //设备报警分析
    drawBarChart() {
      this.myChartBar = this.$refs.chartBar;
      if (this.myChartBar) {
        this.alertChartBar = echarts.init(this.myChartBar);
        let dataAxis = [];
        let numList = [];
        let handList = [];
        if(sessionStorage.getItem("groupId") == 1076){
          dataAxis = [
            "紧急呼叫",
            "设备离线报警",
            "设备异常",
            "其他报警"
           ];
           numList = [
            273,
            57,
            7,
            37
           ];
           handList =  [
            273,
            57,
            7,
            37
           ];
        }else{
        this.alertTypeList.forEach(item => {
          dataAxis.push(item.typeName);
          numList.push(item.number);
          handList.push(item.handleNumber);
        })
        }

        
        let seriesList = [
          {
            name: "报警数",
            type: "bar",
            barGap: "-100%",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(156,107,211,0.8)" },
                  { offset: 0.2, color: "rgba(156,107,211,0.5)" },
                  { offset: 1, color: "rgba(156,107,211,0.2)" }
                ])
              }
            },
            z: 0,
            data: numList
          },
          {
            name: "处理数",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#956FD4" },
                  { offset: 1, color: "#3EACE5" }
                ])
              }
            },
            data: handList
          },
        ];
        var option = {
          animation: true,
          animationDuration:2200, // 动画时长 ms
          tooltip: { //悬浮显示的
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ["报警数", "处理数"],
            textStyle: {
              color: "#3C3C3C"
            },
            top: "0%"
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            data: dataAxis,
            axisLine: {
              lineStyle: {
                color: "#3C3C3C"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: [
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#3C3C3C"
                }
              },

              axisLabel: {
                formatter: "{value} "
              }
            },
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#3C3C3C"
                }
              },
              axisLabel: {
                formatter: "{value} "
              }
            }
          ],
          series: seriesList
        };
        this.alertChartBar.setOption(option);
      }
    },
    //老人年龄分析
    drawLineChart() {
      var myChartLine = this.$refs.chartLine;
      if (myChartLine) {
        this.ageChartLine = echarts.init(myChartLine);
        var option = {
          animation: true,
          animationDuration:2200, // 动画时长 ms
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: ['60岁以下', '60-65岁', '65-70岁', '70-75岁', '75-80岁', '80岁以上']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: this.ageDate,
              type: 'bar',
              itemStyle: {
                normal: {
                  //这里是颜色
                  color: function (params) {
                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                    var colorList = ['#00ABBD', '#FFA100', '#0769CB', '#FFd886', "#9F2E61", "#4D670C"];
                    return colorList[params.dataIndex]
                  }
                }
              }
            },
          ]
        };
        this.ageChartLine.setOption(option);
      }
    },
    drawCharts() {
      this.ordertypeChart() //工单类型分析
    },
    //表格头颜色
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #D4D4D4;";
      }
    },
  },
  components: {
    countTo
  },
  created() {
  },
  mounted: function () {
    //监听父组件websocket的数据变化
    bus.$on("alertNumber", (num) => {
      this.totalAlart = num;
    });
    let that = this;
    bus.$on("collapse-content", (msg) => {
      setTimeout(() => {
        if(that.alertChartBar!=null){
          that.alertChartBar.resize();
          that.ageChartLine.resize();
        }
      }, 200)
    });
    let outjumpFlag = sessionStorage.getItem("outjump");
    if (outjumpFlag && outjumpFlag == 'true') {
      setTimeout(() => {
        that.getOldmanTotal();
        that.oldBirthdayRemind();
        that.queryDeviceAlert();
        that.getDeviceList();
        that.getBedList();
        sessionStorage.removeItem("outjump");
      }, 1700)
      return;
    }
    this.getOldmanTotal();
    this.oldBirthdayRemind();
    this.queryDeviceAlert();
    this.getDeviceList();
    this.getBedList();

  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1600px) {
  .chart-container {
    width: 1350px;
    float: left;
    margin-top: 15px;
  }

  .chart-wapper {
    width: 1500px;
    float: left;
    margin-top: 15px;
  }
}

::v-deep .birthDatas {
  height: 335px;
  overflow-x: hidden;
  overflow-y: scroll;
}

h2 {
  margin: 0;
  padding: 0;
}

.top {
  padding: 2px 10px;
  display: flex;
  justify-content: space-between;

  .inNum {
    width: 190px;
    height: 124px;
    position: relative;
    color: #ffffff;
    cursor: pointer;
    background: url('../../assets/main/ruyuanNum.png') 0 0 no-repeat;
    background-size: 100% 100%;

    h2 {
      font-size: 78px;
      margin: 0;
      padding: 0;
      text-align: center;
      line-height: 108px;
    }

    p {
      width: 190px;
      height: 30px;
      position: absolute;
      bottom: 0;
      background: black;
      opacity: 0.3;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
  }

  .shebeiNum {
    background: url('../../assets/main/shebeiNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .birthNum {
    background: url('../../assets/main/shengriNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .orderNum {
    background: url('../../assets/main/gongdanNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .allNum {
    background: url('../../assets/main/allNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
}

.order {
  width: 30%;
  height: 240px;
  background: #ffffff;
  border-radius: 8px;

  .title {
    display: flex;
    justify-content: space-between;
  }
}

.shebei {
  width: 30%;
  height: 240px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
  position: relative;

  h2 {
    position: absolute;
    top: 10px;
  }
}

.olmanBirthday {
  width: 30%;
  height: 240px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
}
</style>
